import { Helmet } from "react-helmet-async";
import { CONTACT_INFO } from "../data";
import ContactForm from "../components/ContactForm";

export default function Kontakt() {
  const heroImg = "https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/5961f5ff-ebf1-44e6-b9b5-afb30420abff/slide-1-hd-jpeg.webp";

  return (
    <>
      <Helmet>
        <title>Kontakt Halsnæs Epoxygulve | Få et Uforpligtende Tilbud</title>
        <meta
          name="description"
          content="Kontakt Simon Babiel hos Halsnæs Epoxygulve på tlf. 93 80 64 89 eller via vores formular. Vi rådgiver og giver uforpligtende tilbud på dit nye gulv."
        />
        <meta property="og:title" content="Kontakt Halsnæs Epoxygulve | Få et Uforpligtende Tilbud" />
        <meta
          property="og:description"
          content="Kontakt Simon Babiel hos Halsnæs Epoxygulve på tlf. 93 80 64 89 eller via vores formular. Vi rådgiver og giver uforpligtende tilbud på dit nye gulv."
        />
        <meta property="og:image" content={heroImg} />
      </Helmet>

      {/* Page Header (Hero Style) */}
      <section className="bg-brand-dark text-white pt-48 pb-32 md:pt-44 md:pb-28 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src={heroImg}
            alt="Kontakt os baggrund"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/90 to-transparent"></div>
        
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-xs md:text-sm font-extrabold uppercase tracking-widest text-brand-orange mb-3 block">
              Få et uforpligtende tilbud
            </span>
            <h1 className="text-3xl md:text-5xl font-extrabold uppercase tracking-tight text-white leading-tight">
              Kontakt os i dag
            </h1>
            <p className="text-base md:text-lg text-slate-300 mt-4 max-w-2xl leading-relaxed">
              Simon Babiel står altid klar til at besvare dine spørgsmål, yde professionel rådgivning og give et uforpligtende tilbud på dit gulvprojekt.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Details & Form Grid */}
      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            
            {/* Left: Contact Info Cards */}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-4">
                <span className="text-xs md:text-sm font-extrabold uppercase tracking-widest text-brand-orange block">
                  Direkte dialog
                </span>
                <h2 className="text-3xl md:text-4xl font-extrabold text-brand-dark leading-snug uppercase tracking-tight">
                  Lad os tage en uforpligtende snak
                </h2>
                <p className="text-sm md:text-base text-slate-600 leading-relaxed">
                  Uanset om du har brug for et hurtigt prisoverslag, teknisk rådgivning om materialevalg eller ønsker at aftale en uforpligtende besigtigelse af dine lokaler, er du altid velkommen til at kontakte os.
                </p>
              </div>

              {/* Detailed Contact Cards */}
              <div className="space-y-4">
                <a
                  href={`tel:+45${CONTACT_INFO.phone}`}
                  className="flex items-center gap-4 p-5 rounded-none bg-slate-50 border border-slate-200 hover:border-brand-orange transition-all group"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white text-lg group-hover:scale-105 transition-transform">
                    <i className="fa-solid fa-phone"></i>
                  </span>
                  <div>
                    <p className="text-xs text-slate-500 uppercase tracking-wider font-bold">Ring direkte</p>
                    <p className="text-lg font-extrabold text-brand-dark mt-0.5 whitespace-nowrap">{CONTACT_INFO.phone}</p>
                  </div>
                </a>

                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="flex items-center gap-4 p-5 rounded-none bg-slate-50 border border-slate-200 hover:border-brand-orange transition-all group"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white text-lg group-hover:scale-105 transition-transform">
                    <i className="fa-solid fa-envelope"></i>
                  </span>
                  <div>
                    <p className="text-xs text-slate-500 uppercase tracking-wider font-bold">Send en e-mail</p>
                    <p className="text-sm font-extrabold text-brand-dark mt-0.5">{CONTACT_INFO.email}</p>
                  </div>
                </a>

                <div className="flex items-center gap-4 p-5 rounded-none bg-slate-50 border border-slate-200">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white text-lg">
                    <i className="fa-solid fa-location-dot"></i>
                  </span>
                  <div>
                    <p className="text-xs text-slate-500 uppercase tracking-wider font-bold">Adresse</p>
                    <p className="text-sm font-bold text-brand-dark mt-0.5">{CONTACT_INFO.address}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-5 rounded-none bg-slate-50 border border-slate-200">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white text-lg">
                    <i className="fa-solid fa-clock"></i>
                  </span>
                  <div>
                    <p className="text-xs text-slate-500 uppercase tracking-wider font-bold">Åbningstider</p>
                    <p className="text-sm font-bold text-brand-dark mt-0.5">{CONTACT_INFO.hours}</p>
                  </div>
                </div>
              </div>

            </div>

            {/* Right: Contact Form */}
            <div className="lg:col-span-7 w-full bg-slate-50 p-8 rounded-none border border-slate-200 shadow-sm">
              <span className="text-xs md:text-sm font-extrabold uppercase tracking-widest text-brand-orange block mb-2">
                Skriv til os
              </span>
              <h3 className="text-2xl font-extrabold text-brand-dark mb-6 uppercase tracking-tight">
                Send en besked
              </h3>
              <ContactForm source="Kontakt side" />
            </div>

          </div>
        </div>
      </section>

      {/* Full-width Google Maps Section */}
      <section className="w-full overflow-hidden leading-[0] border-t border-slate-200">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110228.67630006836!2d11.943188244468736!3d55.9695070036788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465212d47aa3f5ef%3A0x415d0db90ec1f12d!2s%C3%85sebro%2029%2C%203300%20Frederiksv%C3%A6rk!5e0!3m2!1sen!2sdk!4v1781871528335!5m2!1sen!2sdk"
          className="w-full h-[250px] md:h-[400px] border-0 grayscale hover:grayscale-0 transition-all duration-500 ease-in-out"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map - Åsebro 29, 3300 Frederiksværk"
        ></iframe>
      </section>
    </>
  );
}
